import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TrackingUtils, withPageContext } from '../../../../utils';
import { deleteSegment } from '../../../../redux/currentSearch/actions';
import { TripType, TripTypeProp } from '../../../../models/TripType';

const MULTIPLE_TRIP_MIN = 2;
const ONE_WAY_MIN = 1;

export const DeleteSegment = ({ deleteSegment, tripType, trackEvent, index, render }) => {
    const min = tripType === TripType.MULTIPLE ? MULTIPLE_TRIP_MIN : ONE_WAY_MIN;
    const shouldShow = index > min - 1;

    const onClick = () => {
        const label = TrackingUtils.LABEL.deleteSegment({ tripType, index });
        deleteSegment(index);
        trackEvent({ action: TrackingUtils.ACTION.FLIGHTS, label });
    };

    return (
        <React.Fragment>
            {render({ onClick, shouldShow })}
        </React.Fragment>
    );
};

DeleteSegment.propTypes = {
    deleteSegment: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    render: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
    tripType: TripTypeProp.isRequired,
};

const mapStateToProps = ({ currentSearch }) => ({
    tripType: currentSearch.tripType,
});

export const ConnectedDeleteSegment = connect(mapStateToProps, {
    deleteSegment,
})(withPageContext(DeleteSegment));
